import { verifyMentor } from "../../../ApiServices/ApiServices";
import { getEmail } from "../../../DecodeToken/DecodeToken";
import { handleError, handleSuccess } from "../../../Utils";
import { FaCheckCircle } from "react-icons/fa";

const VerificationModal = ({ onClose, fetchProgressStatus }) => {
  const email = getEmail();

  const handleVerifyClick = async (event) => {
    event.preventDefault();
    try {
      const response = await verifyMentor({ email });
      const { message, success } = response;
      if (success || message) {
        handleSuccess(message);
        fetchProgressStatus();
        setTimeout(() => {
          onClose();
        }, 800);
      }
    } catch (error) {
      const errorMsg = error?.response?.data?.message;
      return handleError(errorMsg);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50 transition-opacity duration-300">
      <div
        className="bg-white w-full max-w-lg mx-auto p-6 rounded-lg relative shadow-lg transform transition-all duration-300 scale-95 hover:scale-100 
          border-4 border-gradient-to-r from-green-400 via-blue-500 to-teal-500"
      >
        <button
          onClick={()=>onClose(false)}
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 focus:outline-none text-3xl "
        >
          &times;
        </button>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center">
          <FaCheckCircle className="w-6 h-6 text-green-500 mr-2" />
          Verify Your Profile
        </h2>

        <div className="border border-gray-300 p-2 rounded-md mb-6">
          <p className="text-gray-700 text-lg">
            To proceed becoming a verified mentor, please complete all the above
            steps. Your profile will be fully verified within 24 hours when all
            criteria are met.
          </p>
        </div>

        <div className="flex justify-center">
          <button
            onClick={handleVerifyClick}
            className="relative text-white font-semibold bg-green-600 py-2 px-10 rounded-lg overflow-hidden focus:outline-none"
            style={{
              position: "relative",
              zIndex: 1,
              display: "inline-block",
              textAlign: "center",
              cursor: "pointer",
            }}
          >
            <span className="z-10">Verify</span>
            <span
              style={{
                position: "absolute",
                top: 0,
                left: "-100%",
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(to right, transparent, rgba(255, 255, 255, 0.5), transparent)",
                zIndex: 0,
                animation: "slide 2s linear infinite",
              }}
            ></span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerificationModal;
